module.exports = __webpack_public_path__ + "img/logo.0ed00e75.png";